export default __webpack_public_path__ + "static/media/bala.b6d0a913.png";